import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpTestService } from "app/services/http.service";

@Component({
  selector: "app-prepaid-payment-fail",
  templateUrl: "./prepaid-payment-fail.component.html",
  styleUrls: ["./prepaid-payment-fail.component.css"],
})
export class PrepaidPaymentFailComponent implements OnInit {
  public decodeMsg: any;
  public url =
    "Y29uc2lkPTMxMDE0MTQmdHhubz0yMDIzMDYxNDA4MjIxNF80MCZiZHR4bm89WFVSMzEyMDY2ODU1MTcmZGVzYz1QYXltZW50IHByb2Nlc3NpbmcgZXJyb3ImdHhuZHQ9MTQtMDYtMjAyMyAyMDoyNDo1NiZwYXlndHk9QklMTERFU0sgUEFZTUVOVCZtZXRubz1jcHM2NTY1JmFtdD0xLjAwJnJtc2c9RkFJTFVSRSZyZW1rcz1QYXltZW50IEZhaWx1cmUh";
  public message: any;
  array: any;

  consumerId: any;
  transactionNo: any;
  billdeskTransaction: any;
  desc: any;
  transactionDateTime: any;
  paymentGateway: any;
  meterNo: any;
  amount: any;
  remarkMessage: any;
  remark: any;

  successMsgSection: boolean = true;
  transSection: boolean = false;
  public serviceOn: boolean = false;

  transactionInfo: any;

  constructor(
    private route: ActivatedRoute,
    public httpService: HttpTestService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.message = params["msg"];

      this.decodeMsg = window.atob(this.message);
      this.array = this.decodeMsg.split("&");

      console.log(this.decodeMsg);

      console.log(this.array);

      this.consumerId = this.array[0].split("=")[1];
      this.transactionNo = this.array[1].split("=")[1];
      this.billdeskTransaction = this.array[2].split("=")[1];
      this.desc = this.array[3].split("=")[1];
      this.transactionDateTime = this.array[4].split("=")[1];
      this.paymentGateway = this.array[5].split("=")[1];
      this.meterNo = this.array[6].split("=")[1];
      this.amount = this.array[7].split("=")[1];
      this.remarkMessage = this.array[8].split("=")[1];
      this.remark = this.array[9].split("=")[1];
    });
  }

  ngOnInit() {}

  transactionDetails() {
    this.serviceOn = true;
    this.httpService
      .prepaidTransactionStatus(this.billdeskTransaction, this.meterNo)
      .subscribe(
        (response) => {
          console.log("response ", response);
          if (response["status"] == 1) {
            if (response["vendorData"].flag == "T") {
              this.successMsgSection = false;
              this.transSection = true;
              this.serviceOn = false;

              this.transactionInfo = response["vendorData"].data[0];
            }
          }
        },
        (error) => {}
      );
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/prepaid-payment-fail/prepaid-payment-fail.component.ts